module.exports = __webpack_public_path__ + "img/dog_11868.b936bf47.png";